import { Population } from "../model/population.types"
import { getRpsRisk, RPS_RISK_AXES, RpsRiskAxis } from "../model/rps-risk"
import RpsRiskCell, { RPS_CELL_WIDTH } from "./RpsRiskCell"

/** Situations RPS d'une fonction, une ligne par axe. */
//isCompact : deux colonnes, sans le texte des situations
export default function RpsSituationsList({
  population,
  isCompact,
  onAxisClick
}: {
  population: Population
  isCompact?: boolean
  onAxisClick?: (axis: RpsRiskAxis) => void
}) {
  return (
    <div className={isCompact ? "grid grid-cols-2 gap-x-[24px]" : ""}>
      {RPS_RISK_AXES.map((axis) => {
        const risk = getRpsRisk(population.rpsRisks, axis.id)
        return (
          <div
            key={axis.id}
            className="grid items-center gap-[16px] py-[4px]"
            style={{ gridTemplateColumns: `${RPS_CELL_WIDTH}px minmax(0,1fr)` }}>
            <RpsRiskCell
              axis={axis.id}
              level={risk?.level ?? null}
              label={axis.label}
              onClick={onAxisClick ? () => onAxisClick(axis.id) : undefined}
            />
            <div className="min-w-0">
              <div className="text-base leading-[20px]">{axis.label}</div>
              {!isCompact &&
                risk?.situations.map((situation, index) => (
                  <p key={index} className="text-sm grey-t truncate leading-[16px]" style={{ margin: 0 }}>
                    {situation}
                  </p>
                ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
